export default __webpack_public_path__ + "static/media/x-bitcoin.c880165a.png";